class Resellers {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
  }

  cacheDOM () {
    this.$terms = $( '#terms' )
    this.$backToTerms = $( '#back-to-terms' )
    this.$acceptedTerms = $( '#accepted-terms' )
    this.$backToAcceptedTerms = $( '#back-to-accepted-terms' )
    this.$backToAcceptedTerms1 = $( '#back-to-accepted-terms-1' )
    this.$backToPurchase = $( '#back-to-purchase' )
    this.$new = $( '#new' )
    this.$payment = $( '#payment' )
    this.$lookup = $( '#lookup' )
  }

  bindEvents () {
    this.handleInputChange()
    this.$backToTerms.on( 'click', this.backToTerms.bind( this ) )
    this.$backToAcceptedTerms.on( 'click', this.backToAcceptedTerms.bind( this ) )
    this.$backToAcceptedTerms1.on( 'click', this.backToAcceptedTerms1.bind( this ) )
    this.$backToPurchase.on( 'click', this.backToPurchase.bind( this ) )
  }

  backToTerms ( event ) {
    event.preventDefault()
    this.$acceptedTerms.addClass( 'hidden' )
    this.$terms.removeClass( 'hidden' )
  }

  backToAcceptedTerms ( event ) {
    event.preventDefault()
    this.$new.addClass( 'hidden' )
    this.$acceptedTerms.removeClass( 'hidden' )
  }

  backToAcceptedTerms1 ( event ) {
    event.preventDefault()
    this.$lookup.addClass( 'hidden' )
    this.$acceptedTerms.removeClass( 'hidden' )
  }

  backToPurchase ( event ) {
    event.preventDefault()
    this.$new.removeClass( 'hidden' )
    this.$payment.add( 'hidden' )
  }

  handleInputChange () {
    $( '.quantity-container input[name=qty]' ).on( 'change', function ( e ) {
      const userNumber = $( this ).val()
      $( this ).siblings( '.fake-input' ).text( `${ userNumber } ${ userNumber > 1 ? 'users' : 'user' }` )
    } )
  }
}

window.Resellers = Resellers